import DividerWithText from "../../../../../components/DividerWithText";
import React from "react";
import {useTranslation} from "react-i18next";
import CustomDateTimePicker from "../../../../../components/CustomDateTimePicker";
import {Box, MenuItem} from "@mui/material";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {useSelector} from "react-redux";
import {CustomTextField} from "../../../../../components/CustomTextField";
import CustomSelectViewCard from "../../../../../components/CustomSelectViewCard";
import NotInformation from "../../../../../components/NotInformation";
import {permissionObj} from "../../../../../Helpers/permission";
import {DEFAULT_VISITOR_TYPE} from "../../Type/Model/Model";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const CreateVisitorInvitationForm = ({ handleChange, disabled, item, emptyFields, selectedList, setSelectedList,
                                         setSelectedHost, selectedHost, setAddShow,
                                         setModified, requestAccessId, isValidStartDate, isValidEndDate }) => {
    const { t } = useTranslation();
    const { employeeWorkStations } = useSelector((state) => state.CompanyEmployeesSlice);
    const getAllVisitorTypes = useSelector((state) => state?.EmployeeEventsSlice?.getAllVisitorTypes);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const minEndDate = item?.startDate ? new Date(new Date(item.startDate).getTime() + 30 * 60 * 1000) : null;

    return (
        <>
            <Box className='row'>
                <div className={'col-12 mb-4 mt-4'}>
                    <DividerWithText title={t('data')} />
                </div>

                <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomDateTimePicker
                        id={'dp_cvif_start_date'}
                        name={'startDate'}
                        disabled={disabled}
                        onChange={(e)=>{
                            handleChange({ target: { value: e, name: 'startDate' } });
                        }}
                        trans={'start_date_at_time'}
                        value={item?.startDate}
                        required={true}
                        disablePast={true}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        maxDate={item.endDate ? new Date(item.endDate) : undefined}
                        isValid={isValidStartDate}
                        isValidText={'start_date_must_be_in_the_future'}
                    />
                </Box>
                <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomDateTimePicker
                        id={'dp_cvif_end_date'}
                        name={'endDate'}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'endDate' } });
                        }}
                        disabled={!item?.startDate}
                        trans={'end_date_at_time'}
                        value={item?.endDate}
                        required={true}
                        disablePast={true}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        minDateTime={minEndDate}
                        isValid={isValidEndDate}
                        isValidText={'end_date_must_be_30min_later'}
                    />
                </Box>
                <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren
                        id="slc_cvif_zone_id"
                        name="zoneId"
                        value={item?.zoneId}
                        onChange={(evt) => {handleChange(evt, "zoneId")}}
                        trans="access_zone"
                        required={true}
                        emptyFields={emptyFields}
                        label="lbl_cvif_zone_id"
                        showNoSelectionOption={false}
                    >
                        {employeeWorkStations?.map((item) => (
                            <MenuItem value={item.id}>{item.name}</MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </Box>
                <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomTextField id={"txt_cvif_visitor_number"}
                                     length={2}
                                     name={"visitorNumber"}
                                     type={'number'}
                                     placeholder={t("placeholder_guest_count")}
                                     value={item.visitorNumber}
                                     trans={"guest_count"}
                                     onChange={(evt) => {handleChange(evt, "visitorNumber")}}
                    />
                </Box>
                <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <CustomAddChipSearch
                        autocompleteId={'slt_cvif_host'}
                        buttonId={'btn_cvif_host'}
                        selectedList={selectedHost}
                        setSelectedList={setSelectedHost}
                        userTypeIdsSearch={[
                            USER_TYPE_MODEL.EMPLOYEE
                        ]}
                        disabled={requestAccessId}
                        label="host"
                        required={false}
                        reset={false}
                        hideButton={false}
                        keyId={"userId"}
                        showRenderOption={true}
                        helperText={t('host_no_required')}
                        maxLength={1}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                </Box>
                <div className={'col-12 mb-4 mt-4'}>
                    <DividerWithText title={t('visitor')} />
                </div>
                <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <CustomSelectViewCard
                        id='slt_cvif_visitor_types'
                        list={getAllVisitorTypes.filter(e => e.name !== DEFAULT_VISITOR_TYPE)}
                        value={item?.visitorType}
                        name='visitorType'
                        trans='select_visitor_type'
                        required={true}
                        onChange={(evt) => {handleChange(evt, "visitorType")}}
                        className='w-100'
                        showNoSelectionOption={false}
                        emptyFields={emptyFields}
                        disabled={disabled}

                    />
                </Box>
                <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-5'>
                    <CustomAddChipSearch
                        id="slt_cvif_visitor"
                        buttonId={'btn_cvif_visitor'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        userTypeIdsSearch={[
                            USER_TYPE_MODEL.VISITOR
                        ]}
                        disabled={requestAccessId}
                        label="visitor"
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        hideButton={false}
                        keyId={"userId"}
                        showRenderOption={true}
                        noOptionsCard={(DEV || permission.includes(permissionObj?.WEB_VISITOR_CREATE)) && (
                            <NotInformation
                                card={false}
                                text={t('no_visitor_search_text')}
                                showButton={true}
                                buttonId={'btn_cvf_link_create'}
                                buttonOnclick={() =>   {
                                    setAddShow(true);
                                    setModified(true);}}
                                buttonTrans={'create_a_new_visitor'}
                            />
                        )
                        }
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                </Box>
            </Box>

        </>
    )
}

export default CreateVisitorInvitationForm
